export const GET_FEATURE_FLAG_DETAILS_URL = 'https://gitlab.lelyonline.com/api/v4/projects/1111/feature_flags/';
export const GITLAB_ACCESS_TOKEN = '3svXy2cxJNvW3S_bmnrL';